import "@repo/utils/UString";

import UIterable from "@repo/utils/UIterable";

import Platform from "./Platform.mjs";

namespace Env {
  export let debug = false;
  export const resolveUrl = <T extends string | undefined>(
    rule: T,
    baseUrl = Platform.isClient ? window.location.origin : ""
  ): string | Extract<T, undefined> => {
    if (!rule) return rule as never;
    // Double pipe to disambiguate from | in regex pattern
    const directives = rule.split("||");
    if (!baseUrl) return "";
    const res = UIterable.firstDerived(directives, (directive) => {
      if (!directive.startsWith("/")) return directive;
      const [pattern, replacement] = directive.slice(1, -1).split(
        // Does not support escaping \ in front of /
        /(?<!\\)\//
      );
      if (!replacement) throw new Error(`Invalid url directive: ${directive}`);
      const regex = new RegExp(pattern);
      if (!regex.test(baseUrl)) return;
      return baseUrl.replace(regex, replacement);
    });

    if (!res)
      throw new Error(
        `Base URL ${baseUrl} does not match any directives provided in rule: ${rule}`
      );

    return res;
  };
}

export default Env;
